const CLIENT_GLOBAL_ENABLED = String(process.env.REACT_APP_CLIENT_GLOBAL).toLowerCase() === 'true';

const actionLabels = {
    ru: {
        deposit: 'Депозит',
        withdraw: 'Вывод',
        bonus: 'Бонус',
        credit: 'Кредит',
        bank_liquidity: 'Банковская ликвидность',
    },
    en: {
        deposit: 'Deposit',
        withdraw: 'Withdraw',
        bonus: 'Bonus',
        credit: 'Credit',
        bank_liquidity: 'Bank liquidity',
    },
};

const normalizeDisplayAction = (action) => {
    if (CLIENT_GLOBAL_ENABLED && action === 'bonus') {
        return 'credit';
    }

    return action;
};

export const getTransactionActionLabel = (action, lang = 'en') => {
    const normalizedAction = normalizeDisplayAction(action);
    const labels = actionLabels[lang] || actionLabels.en;

    return labels[normalizedAction] || normalizedAction || '';
};

export const shouldDisplayBonusAsCredit = () => CLIENT_GLOBAL_ENABLED;
